module.exports = __webpack_public_path__ + "static/media/leozao.fb204989.png";